

export const useVlogsStore = defineStore('vlogs', () => {
  const filters = ref({
    selectedSeasons: {} as Record<string, boolean>,
  })

  const filtersDraft = ref({
    selectedSeasons: {} as Record<string, boolean>,
  })

  const availableSeasons = ref<string[]>([])

  const clearFilters = () => {
    filters.value.selectedSeasons = {}
    filtersDraft.value.selectedSeasons = {}
  }

  return {
    filters,
    clearFilters,
    availableSeasons,
    filtersDraft,
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useVlogsStore, import.meta.hot))
}
